import React, { useRef, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import LandingSection from "../components/LandingSection";
import ActionButton from "../utils/ActionButton";
import Footer from "../components/Footer";
import "../styles/Faq.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry,
  faChartLine,
  faCogs,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import { FaqSection } from "./FaqSection";
//import { FaqSection } from './FaqSection';
import "../styles/Aerospace.css";
import ModalFunction from "./Modal";
import { FoodIndustryFaqSection } from "./FoodIndustryFaqSection";
import TabTitle from "../components/TabTitle";
import DataSources from "../components/DataSources";

const logo = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";

export default function FoodIndustry() {
    const [expanded, setExpanded] = useState(false);
    const navbarRef = useRef(null);
    const [modalShow, setModalShow] = React.useState(false);
  
    // Close dropdown when clicking outside the navbar
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (navbarRef.current && !navbarRef.current.contains(event.target)) {
          setExpanded(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  return (
    <div>
     <LandingSection
        data={{ imageName: "FoodIndustry.webp", title: "Food Industry" }}
      />
       <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah's Food Industry: A Growing Economic Force</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
            Utah's food industry plays a vital role in the state's economy, encompassing agriculture, food processing, manufacturing, and distribution. Known for its innovation and sustainability practices, the sector supports thousands of jobs and continues to grow, driven by strong local demand and national exports.

            </p>
            
          </div>
        </div>
      </div>
        <TabTitle/>
        <FoodIndustryFaqSection/>
        <DataSources
          sources={[
            "https://ledextract.ces.census.gov/qwi/all",
            "https://opendata.gis.utah.gov/datasets/7a887f592459424a8bdeb69a3bf08df4_0/explore",
          ]}
        />
      <Footer/>
    </div>
  )
}

